import React from "react";

export default function PrivacyPage() {
  return (
    <div className="privacy-page" dir="rtl">
      <div className="privacy-card">
        <h1>Noura AI — الخصوصية والشروط 🎓</h1>
        <p className="privacy-updated">آخر تحديث: 2026</p>

        <h2>1. مين إحنا</h2>
        <p>
          Noura AI هو مساعد أكاديمي ذكي لطلاب اللغة الإنجليزية التطبيقية بجامعة اليرموك.
          هدفه مساعدتك تفهمي المواد وتستعدي للامتحانات — مش بديل عن الدراسة أو حل الواجبات عنك.
        </p>

        <h2>2. شو البيانات اللي بنجمعها</h2>
        <ul>
          <li><b>اسمك وإيميلك</b> — لإنشاء حسابك وتسجيل الدخول.</li>
          <li><b>محادثاتك</b> — بنحفظها عشان ترجعيلها لاحقاً.</li>
          <li><b>كلمة السر</b> — مُشفّرة بالكامل (bcrypt)، ما حدا يقدر يشوفها حتى نحنا.</li>
        </ul>

        <h2>3. كيف بنستخدم بياناتك</h2>
        <p>
          بنستخدمها فقط لتشغيل التطبيق (حفظ محادثاتك، تخصيص تجربتك).
          <b> ما بنبيع بياناتك ولا بنشاركها مع أي جهة إعلانية.</b> الأسئلة تُرسل لخدمة Google Gemini
          لتوليد الإجابات حسب سياسة Google.
        </p>

        <h2>4. الاستخدام الأكاديمي</h2>
        <p>
          Noura AI أداة مساعدة للفهم. الغش أو تسليم إجابات الذكاء كواجب هو مسؤوليتك الشخصية
          ويخالف سياسات جامعتك. استخدميه للتعلّم 💪.
        </p>

        <h2>5. حقوقك</h2>
        <p>
          تقدري تحذفي محادثاتك أي وقت، وتطلبي حذف حسابك. للتواصل: راجعي مطوّر التطبيق.
        </p>

        <button className="privacy-back" onClick={() => { window.location.href = "/"; }}>
          ← رجوع
        </button>
      </div>
    </div>
  );
}
